import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExpensesService } from '../../services/expenses.service';
import { IExpenses } from '../../interfaces/expenses/iexpenses';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';
import { ProfessionalService } from '../../services/professional.service';
import { IProfessional } from '../../interfaces/professional/iprofessional';
import { SpecialtiesService } from '../../services/specialties.service';
import { ISpecialties } from '../../interfaces/profession/iprofession';

@Component({
  selector: 'split-filter-specialties',
  templateUrl: './split-filter-specialties.component.html',
  styleUrls: ['./split-filter-specialties.component.scss']
})
export class SplitFilterSpecialtiesComponent {
  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;
  @Input() groupId!: string;

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private specialtiesService: SpecialtiesService) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    let filter = this.filter.convertFilterInQuery();
    this.specialtiesService.getAll(filter).pipe(
      map((res: any) => res['hydra:member']),
      map((specialties: ISpecialties[]) => specialties.map(specialtie => ({ name: specialtie.name, id: specialtie.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        console.log(data);
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }
}
